module.exports = __webpack_public_path__ + "img/hitachi.ce84e088.svg";